import React from 'react'
import { DashboardLayout } from '../layouts'
import { ResponsesTopBar } from '../containers'
import { useState } from 'react';
import { useEffect } from 'react';
import services from '../../ioc/services';
import { format } from 'date-fns';
import { useLocation, useNavigate } from 'react-router-dom';
import { downloadFileFromBlob } from '../../application/utils/FileUtil';

function Responses() {

    const { state } = useLocation();

    const navigate = useNavigate();

    const [selectedAgents, setSelectedAgents] = useState([]);

    const [selectedForms, setSelectedForms] = useState([]);

    const [allResponses, setAllResponses] = useState([]);

    const [responses, setResponses] = useState([]);

    const [isSelecting, setIsSelecting] = useState(false);

    const [selectedResponses, setSelectedResponses] = useState([]);

    useEffect(() => {
        services.api.form.getAllFormResponses()
            .then(res => {
                setAllResponses(res)
            })
    }, [])

    useEffect(() => {

        //filter responses based on selected agents and forms
        let filteredResponses = allResponses;
        if (selectedAgents.length > 0) {
            filteredResponses = filteredResponses.filter(response => selectedAgents.includes(response.filledBy._id));
        }
        if (selectedForms.length > 0) {
            filteredResponses = filteredResponses.filter(response => selectedForms.includes(response.form_id));
            if (selectedForms.length > 1) {
                setIsSelecting(false);
                setSelectedResponses([]);
            }
        }

        setResponses(filteredResponses);
    }, [selectedAgents, selectedForms, allResponses])

    useEffect(() => {
        if (state) {
            setSelectedForms([state?.formId])
        }
    }, [state])

    useEffect(() => {

    }, [selectedResponses])

    const handleResponseClick = (response) => {

        if (isSelecting) {
            if (selectedResponses.includes(response._id)) {
                setSelectedResponses(selectedResponses.filter(r => r != response._id))
            } else {
                setSelectedResponses([...selectedResponses, response._id])
            }
        }
        else {
            //redirect to response page
            navigate(`/form/responses/${response._id}`)
        }
    }

    const handleExport = (inResponses = null) => {

        const responsesToExport = inResponses ?? selectedResponses;

        if (responsesToExport.length == 0) {
            services.alert.toast.error('Please select at least one response to export');
            return;
        }
        if (selectedForms.length > 1) {
            services.alert.toast.error('Please select only one form to export');
            return;
        }

        setIsSelecting(false);
        setSelectedResponses([]);

        console.log(responsesToExport);
        console.log(selectedForms[0]);

        services.api.form.exportSelectedFormResponses(selectedForms[0], {
            responses: responsesToExport
        })
            .then(res => {
                downloadFileFromBlob(res, `Responses.csv`)
                services.alert.toast.success("Downloaded Successfully")
            })
            .catch(err => {
                services.alert.toast.error(err)
            })
    }


    return (
        <DashboardLayout>
            <div className="flex flex-col gap-5">
                <div>

                    <div className=' flex items-center gap-6'>
                        <ResponsesTopBar
                            selectedAgents={selectedAgents}
                            selectedForms={selectedForms}
                            setSelectedAgents={setSelectedAgents}
                            setSelectedForms={setSelectedForms} />

                        {selectedForms.length == 1 && !isSelecting && <button
                            className='bg-green-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-green-600'
                            onClick={() => setIsSelecting(true)}
                        >
                            Select and Export
                        </button>}

                        {
                            isSelecting && <div className='flex items-center gap-2'>
                                <button
                                    className='bg-green-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-green-600'
                                    onClick={() => handleExport()}>
                                    Export {selectedResponses.length} responses
                                </button>

                                <button
                                    className='border border-green-500 text-black px-4 py-2 rounded-md shadow-md hover:bg-green-600 hover:text-white'
                                    onClick={() => { handleExport(responses.map(r => r._id)) }}>
                                    Export All
                                </button>

                                <button className='bg-red-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-red-600' onClick={() => {
                                    setIsSelecting(false)
                                    setSelectedResponses([])
                                }
                                }>Cancel</button>
                            </div>


                        }
                    </div>

                </div>

                <div>
                    {responses && <div className=' grid grid-cols-3 gap-8 '>
                        {responses.map(response =>
                            <div
                                className='border border-gray-100 shadow-md rounded-md p-3 flex gap-3 cursor-pointer hover:shadow-xl'
                                key={response._id}
                                onClick={() => handleResponseClick(response)}
                            >
                                <div className=' flex  flex-1 flex-col gap-3'>
                                    <h1>{response.form_id}</h1>
                                    <h1>Form: {response.form.title}</h1>
                                    <h1>
                                        Agent: {response.filledBy.firstName} {response.filledBy.lastName}
                                    </h1>
                                    <div>
                                        {format(new Date(response.createdAt), "PPPp")}
                                    </div>
                                </div>
                                <div>
                                    {isSelecting && <input type="checkbox"
                                        checked={selectedResponses.includes(response._id)} />}
                                </div>

                            </div>
                        )}
                    </div>}
                </div>
            </div>
        </DashboardLayout>
    )
}

export default Responses